import { AppSelectLocale } from "../index";

const locale: AppSelectLocale = {
  placeholder: "",
  title: "",
};

export default locale
